import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesComponent } from 'app/dashboard/domains/routes/routes.component';
import { Driver } from 'app/models/driver.model';
import { Route } from 'app/models/route.model';
import { StopI } from 'app/models/stop.interface';
import { Vehicle } from 'app/models/vehicle.model';
import { DriverService } from 'app/services/driver/driver.service';
import { LocationService } from 'app/services/locations/location.service';
import { Location } from 'app/models/location.model'
import { MapboxService } from 'app/services/mapbox/mapbox.service';
import { RouteService } from 'app/services/routes/route.service';
import { VehiclesService } from 'app/services/vehicle/vehicles.service';
import { openAlert } from 'app/utils/alert.util';
import { RecurrencyService } from 'app/services/recurrency/recurrency.service';
import { Travel } from 'app/models/travel.model';
import { User } from 'app/models/user.model';
import { TravelService } from 'app/services/travel/travel.service';
import { isNull } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-route-detail',
  templateUrl: './route-detail.component.html',
  styleUrls: ['./route-detail.component.css']
})
export class RouteDetailComponent implements OnInit {

  hour: string;
  locations: Location[];
  vehicles: Vehicle[];
  drivers: Driver[];
  recurrencies: any[];
  selectedLocation = new FormControl('');
  stop: StopI;
  assignedLocations: StopI[] = [];
  // assignedLocationsAeeay: StopI[] = [];
  route: Route = new Route();
  assignedLocationsDataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ["order", "description", "action"];
  dataSource = this.assignedLocations;
  // years = ['2020', '2021'];
  domainId: number;
  description: string;
  // routesForm: FormGroup;
  resumeRouteHeader: {
    vehicle: any, driver: any, initTime: any, eta: any, distance: any
  } = {vehicle: {model: {description: ''}}, driver: '', initTime: '', eta: '', distance: ''};
  routeId: number;  
  routesForm : FormGroup;
  // routeDetail;
  isRecurrent: boolean = false;
  travel: Travel;
  enterprise: User;
  initTimeControl : FormControl;
  driverControl : FormControl;
  vehicleControl : FormControl;
  recurrencyControl : FormControl;
  isTravelControl : FormControl;
  stopsControl : FormControl;
  dateControl : FormControl;
  descriptionControl : FormControl;


  constructor(
    private formBuilder: FormBuilder,
    // private dialogRef: MatDialogRef<RoutesComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private activatedRouter: ActivatedRoute,
    private locationService: LocationService,
    private mapboxService: MapboxService,
    private vehicleService: VehiclesService,
    private driverService: DriverService,
    private routeService: RouteService,
    private recurrencyService: RecurrencyService,
    private router: Router,
    private travelService: TravelService) {
      this.loadFormControls();

      this.routesForm = new FormGroup({
        description: this.descriptionControl,
        isTravel: this.isTravelControl,
        driver: this.driverControl,
        date: this.dateControl,
        initTime: this.initTimeControl,
        vehicle: this.vehicleControl,
        stops: this.stopsControl,
        recurrency: this.recurrencyControl
      });
      
    }

  async ngOnInit() {
    this.enterprise = JSON.parse(sessionStorage.getItem('loggedUser'));
    this.isRecurrent = history.state.isRecurrent;
    console.log('is travel?', this.isRecurrent);
    this.domainId = this.activatedRouter.snapshot.params.id;
    await this.initLoad();
    this.routeId = this.activatedRouter.snapshot.params.routeId;
    if(this.routeId){
      console.log('actualizar ruta ', this.routeId);
      this.route = await this.routeService.getRoute(this.routeId);
      this.descriptionControl.setValue(this.route.description);
      this.driverControl.setValue(this.route.driver.id);
      this.isTravelControl.setValue(this.route.recurrency !== null);
      this.vehicleControl.setValue(this.route.vehicle.id);
      this.hour = this.route.initTime.slice(0, -3).toString();
      this.initTimeControl.setValue(this.hour);
      this.stopsControl.setValue(this.route.locationsRoute);
      this.recurrencyControl.setValue(this.route.recurrency.id)
      this.assignedLocations = this.stopsControl.value
      this.assignedLocationsDataSource = new MatTableDataSource<any>(this.stopsControl.value);
      console.log('paradas asignadas', this.stopsControl.value);
      console.log('Formulario', this.routesForm.value)
      console.log('assignedLocations on init', this.assignedLocations);
      
    }else{
      console.log('Nueva ruta');
      this.assignedLocationsDataSource = new MatTableDataSource<any>(this.stopsControl.value);
    }
  }

  ngAfterViewInit(): void {
    // this.assignedLocations
  }

  async initLoad(){
    console.log('Cargando ubicaciones...');
    this.locations = await this.locationService.getLocations(this.domainId);
    console.log('ubicaciones', this.locations);
    this.hour = '06:00 am';
    console.log('Cargando vehiculos...');
    this.vehicles = await this.vehicleService.getVehicles();
    console.log('Cargando conductores...')
    this.drivers = await this.driverService.getDrivers();
    console.log('Cargando catalogo de recurrencias');
    this.recurrencies = await this.recurrencyService.getRecurrencies();
  }

  loadFormControls(){
    this.descriptionControl = new FormControl('', Validators.required);
    this.initTimeControl = new FormControl('', Validators.required);
    this.driverControl = new FormControl('', Validators.required);
    this.vehicleControl = new FormControl('', Validators.required);
    this.recurrencyControl = new FormControl('');
    this.isTravelControl = new FormControl(false);
    this.dateControl = new FormControl('');
    this.stopsControl = new FormControl([]);
  }

  loadForm(){
    // this.loadFormControls();
    this.routesForm = new FormGroup({
      description: this.descriptionControl,
      initTime: this.initTimeControl,
      driver: this.driverControl,
      vehicle: this.vehicleControl,
      recurrency: this.recurrencyControl,
      isTravel: this.isTravelControl,
      date: this.dateControl,
      stops: this.stopsControl
    })
  }

  saveRoute(){
    console.log('formulario on save route', this.routesForm.value);
    console.log('recurrente?', this.routesForm.value.isTravel)
    if(this.routesForm.value.isTravel){
      // this.routesForm.value.recurrency = true;
      // this.routesForm.removeControl('date');
    }else{
      this.routesForm.value.recurrency = null;
      // this.recurrencyControl.disable();
      // this.routesForm.removeControl('recurrency');
    }
    console.log('paradas a grabar', this.routesForm.value.stops);
    this.routesForm.value.stops = this.assignedLocations;
    // this.assignedLocations.forEach(stop => {
    //   this.routesForm.value.stops.push({position: stop.position, location: stop.location.id});
    //   console.log('agregando paradas', {position: stop.position, location: stop.location.id});
    // });
    console.log('STATUS FORM: ', this.routesForm.status);
    this.findInvalid();
    if(this.routesForm.status === 'INVALID' || this.routesForm.value.stops.length < 2){
      console.log(this.routesForm.value);
      openAlert(0);
    }else{
      console.log('form valid', this.routesForm.value);
      if(this.routesForm.value.isTravel){
        console.log('es recurrente');
        this.saveRecurrentRoute();
      }else{
        console.log('es un viaje');
        this.saveNonRecurrentRoute();
      }
    }
  }

  findInvalid(){
    let controls = this.routesForm.controls;
    let invalid = [];
    for (const name in controls) {
      if(controls[name].invalid){
        invalid.push(name);
      }
    }
    console.log('invalid control', invalid);
  }

  private saveRecurrentRoute(){
    let routeFormValue = this.routesForm.value;
    
    this.route = {
      description: routeFormValue.description,
      domain: this.domainId,
      vehicle: routeFormValue.vehicle,
      driver: routeFormValue.driver,
      initTime: routeFormValue.initTime,
      recurrency: routeFormValue.recurrency,
      locationsRoute: routeFormValue.stops,
    }
    if(this.routeId){
      this.route.id = parseInt(this.routeId.toString());
    }
    console.log('recurrent route to save', routeFormValue);
    this.routeService.saveRoute(this.route).subscribe((res) => {
      openAlert(1);
      this.back();
    });
  }

  private saveNonRecurrentRoute(){
    let routeFormValue = this.routesForm.value;
    this.route = {
      description: routeFormValue.routeHeader.description,
      domain: this.domainId,
      vehicle: routeFormValue.routeHeader.vehicle,
      driver: routeFormValue.routeHeader.driver,
      initTime: routeFormValue.routeHeader.initTime,
      recurrency: routeFormValue.routeHeader.recurrency,
      locationsRoute: routeFormValue.routeStops.stops,
    }
    if(this.routeId){
      this.route.id = parseInt(this.routeId.toString());
    }
    this.travel = {
      initTime: routeFormValue.routeHeader.initTime,
      date: routeFormValue.routeHeader.date,
      domain: this.domainId,
      enterprise: this.enterprise.databaseId
    }
    this.routeService.saveRoute(this.route).subscribe((route) => {
      this.travel.route = route;
      this.travelService.saveTravel(this.travel).subscribe((res) => {
        openAlert(1);
        this.back();
      });
    });
  }

  addStop(){
    // console.log(this.selectedLocation);
    try {
      this.stop = {
        location: this.selectedLocation.value,
        position: this.calculatePosition(),
        // hour: this.hour.toUpperCase()
      }
      console.log(this.stop);
      console.log('data source', this.assignedLocationsDataSource);
      this.assignedLocations.push(this.stop);
      this.assignedLocationsDataSource.data = this.assignedLocations;
      // this.assignedLocationsDataSource.data.push(this.stop)
      console.log('stop added: ', this.selectedLocation.value);
      console.log('dataSource: ', this.assignedLocationsDataSource.data);
    } catch (error) {
      console.error('Error agregando stop', error);
    }
  }

  back(){
    this.router.navigateByUrl(`dashboard/domains/${this.domainId}/routes`);
  }

  private calculatePosition(){
    let position: number;
    if(this.assignedLocations.length == 0){
      position = 1
    }else{
      position = this.assignedLocations.length + 1
    }
    return position;
  }

  private calculatePositionForStopList(){
    this.assignedLocations.forEach((stop, index) => {
      stop.position = index + 1
    });
  }

  private moveUp(stop: StopI){
    console.log('Up ',stop)
    this.move(stop.position, stop.position - 1);
  }

  private moveDown(stop){
    console.log('Down', stop);
    this.move(stop.position, stop.position + 1);
  }

  private move(origin, destination){
    var temp = this.assignedLocations.find(l => l.position == origin);
    var x = this.assignedLocations.find(l => l.position == destination);
    var y = temp;
    y.position = x.position;
    x.position = temp.position;
  }

  /*Funcion corregida, is done!*/
  private delete(stop){
    let stopToDelete = this.assignedLocations.indexOf(stop);
    this.assignedLocations.splice(stopToDelete, 1);
    this.calculatePositionForStopList();
    this.assignedLocationsDataSource.data = this.assignedLocations;
    console.log('Paradas despues de eliminar', this.assignedLocationsDataSource.data);
    console.log('assigned locations', this.assignedLocations);
    
  }

  buildMap(){
    
    this.mapboxService.getDirection(this.assignedLocations).subscribe((result) => {
      this.mapboxService.buildRouteMap(result, this.assignedLocations);
      this.resumeRouteHeader = {
        vehicle: this.vehicles.find(v => v.id == this.routesForm.value.vehicle),
        driver: this.drivers.find(d => d.id == this.routesForm.value.driver),
        initTime: this.routesForm.value.initTime,
        // eta: result.routes[0].duration,
        eta: new Date(result.routes[0].duration * 1000).toISOString().substr(11, 8),
        // distance: result.routes[0].distance
        distance: this.distanceInKm(result.routes[0].distance)
      }
    })
  }

  private distanceInKm(distance) {
    let distanceInKm = distance / 1000;
    let t=distanceInKm.toString();
    let regex=/(\d*.\d{0,2})/;
    return t.match(regex)[0];
  }

  private travelToggle(){
    console.log('es viaje?', this.routesForm.value.isTravel);
  }

  
}
